import { Help } from "@/pages/help/Help.tsx";
import { HelpArticle } from "@/pages/help/HelpArticle.tsx";
import { HelpCollection } from "@/pages/help/HelpCollection.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";

export const helpRoutes: RouteConfig[] = [
  {
    path: "/help",
    children: [
      {
        path: "",
        element: <Help />,
      },
      {
        path: "collection/:slug",
        element: <HelpCollection />,
      },
      {
        path: "article/:slug",
        element: <HelpArticle />,
      },
    ],
  },
];
